import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { ProfileSettings } from '../../../common/model/profile-settings';
import { ProfileService } from '../../../common/service/data/profile.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { getMonthName } from '../../../core/helper/month';
import { getTranslation } from '../../../core/helper/translation';
import { FilterDefinitionItem, FilterDefinitionItemLocalDate } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { UnpaidInvoiceCommandHandlerResolver } from '../../service/command/unpaid-invoice-command-handler-resolver.service';
import { InvoiceListComponentBase } from '../base/invoice-list.base';
import { CustomPropertyService } from '../../../rent/service/data/custom-property.service';
import { CustomPropertyHelper } from '../../../rent/helper/customproperties-helper';
import { standardCommand } from '../../../core/model/command';
import { RentInvoicingOrderInvoiceService } from '../../../rent/service/data/rent-invoicing/rent-invoicing-order-invoice.service';
import { InvoiceService } from '../../service/data/invoice.service';

@Component({
    selector: 'app-rent-invoicing-order-invoices',
    templateUrl: './invoice-list-rent-invoicing-order.html',
    styleUrls: ['./invoice-list-rent-invoicing-order.scss'],
    providers: [DeleteCommandHandler, UnpaidInvoiceCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceListRentInvoicingOrderComponent extends InvoiceListComponentBase implements OnInit {
  constructor(
    private readonly _dataService: InvoiceService,
    private readonly _listService: RentInvoicingOrderInvoiceService,
    accountService: UserAccountService,
    dispatcher: CommandDispatcher,
    factory: ColumnDefinitionFactory,
    handlerResolver: UnpaidInvoiceCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(factory, accountService, _dataService, dispatcher, handlerResolver, messageService, navigationService, _listService);

    this.AddSubscription(
      accountService.current.subscribe({
        next: account => (this.allowNew = account.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)),
      })
    );
  }
  @Input() rentInvoicingOrderId: string;

  getPagingChangedFallbackFilter(): any {
    return { selectedFields: ['rentInvoicingOrderId'], rentInvoicingOrderId: this.rentInvoicingOrderId };
  }

  reload() {
    this.onFilterChange(this.getPagingChangedFallbackFilter());
  }

  ngOnInit() {
    this.addContextMenuItemDefinition('DELETE_BTN', standardCommand.delete);
    this.filterDefinition = [new FilterDefinitionItem('Id', 'rentInvoicingOrderId', this.rentInvoicingOrderId, null, true)];
    this.reload();
  }

  onRowClicked(e: { context: any; event: any }) {
    this.navigation.navigate(['invoices', 'edit', e.context.id], null, e.event.ctrlKey);
  }
}
